import styles from '@activities/gift/GiftSentActivity/components/RefundButton/styles.module.scss';
import GiftOrderApi from '@apis/gift/GiftOrderApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import useToast from '@hooks/ui/useToast';
import ModalContainer from '@modals/ModalContainer';
import { ErrorResponse } from '@models/error';
import { CancelGiftOrderRequest } from '@models/gift';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { AxiosError } from 'axios';

const GiftCancelModal: ActivityComponentType<CancelGiftOrderRequest> = ({ params }:{params: CancelGiftOrderRequest}) => {
  const { pop, push } = useFlow();
  const toast = useToast();
  const handleCancel = () => {
    GiftOrderApi.cancelOrder(params)
      .then(() => {
        pop(2);
        push('GiftCanceledModal', {});
      }).catch((e: AxiosError<ErrorResponse>) => {
        toast.error(e.message);
      });
  };
  return (
        <Modal>
            <ModalContainer>
                <Column spacing={32} fullWidth>
                    <Column spacing={8}>
                        <Text size='3xl' fontWeight='bold' className={styles.title}>
                            결제 취소하시겠습니까?
                        </Text>
                        <Text size='xl' align='center'>
                            선물하신 쿠폰을 사용하실 수 없습니다.
                        </Text>
                    </Column>
                    <Column fullWidth spacing={8}>
                        <Button variant='secondary' fullWidth
                                onClick={pop} >
                            취소
                        </Button>
                        <Button fullWidth onClick={handleCancel}>
                            결제취소
                        </Button>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default GiftCancelModal;
